import { Row, Table } from "antd";
import { useFetchData } from "./hooks/useFetchData";
import { useGetBatchTableColumns } from "./hooks/useGetBatchTableColumns";
import { TablePagination } from "../../components/TablePagination";
import { useFetchCount } from "./hooks/useFetchCount";
import { useCallback, useMemo, useState } from "react";
import { ExpandableConfig } from "antd/es/table/interface";
import { NavigateFunction, useNavigate } from "react-router-dom";
import ROUTES from "../../configs/routesConfig";
import { Header } from "./components/Header";
import "./styles.scss";

export const Processing = () => {
  const navigate: NavigateFunction = useNavigate();

  const navigateToBatch = useCallback(
    (id: string) => {
      navigate(`${ROUTES.PROCESSING}/${id}`);
    },
    [navigate]
  );

  const onRow = useCallback(
    (record: any) => ({
      onClick: () => !record.children && navigateToBatch(record.id),
    }),
    [navigateToBatch]
  );

  const [isOpenEditModal, setIsOpenEditModal] = useState<boolean>(false);

  const [id, setId] = useState<string | null>(null);

  const {
    total,
    request,
    isLoading: isCountLoading,
    onPageChange,
    fetchCount,
  } = useFetchCount();

  const { isLoading, fetchData, data } = useFetchData(request);

  const reloadData = useCallback((): void => {
    fetchCount();
    fetchData();
  }, [fetchCount, fetchData]);

  const { columns } = useGetBatchTableColumns({
    setIsOpenEditModal,
    setId,
    reloadData,
    navigateToBatch,
  });

  const tableExpandabelProp: ExpandableConfig<any> = useMemo(
    () => ({
      defaultExpandAllRows: true,
      indentSize: 0,
      expandIcon: () => <span className="d-none" />,
    }),
    []
  );

  return (
    <>
      <Row className="table-page-content w-100 px-8">
        <Row className="d-block w-100">
          <Row className="my-6">
            <h3 className="h h3">Processing</h3>
          </Row>
          <Row className="w-100">
            <Header
              request={request}
              id={id}
              isOpenEditModal={isOpenEditModal}
              setId={setId}
              setIsOpenEditModal={setIsOpenEditModal}
              reloadData={reloadData}
            />
          </Row>
        </Row>
        <Row className="d-block table__container w-100 pt-2 processing-table">
          <Table
            key={data.length}
            dataSource={data}
            loading={isLoading}
            columns={columns}
            pagination={false}
            className="overflow-y-auto clickable-rows-table"
            rowKey="id"
            expandable={tableExpandabelProp}
            onRow={onRow}
          />
          <TablePagination
            total={total}
            isTotalLoading={isCountLoading}
            currentPage={request?.pageNumber || 1}
            pageSize={request?.pageSize || 20}
            onPageChange={onPageChange}
          />
        </Row>
      </Row>
    </>
  );
};
